import { Reveal } from "./motion";

export const SectionHead = ({ chapter, kicker, title, sub, dark = false, center = false }) => (
  <Reveal className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    <div className={`flex items-center gap-3 ${center ? "justify-center" : ""}`}>
      {chapter && (
        <span className={`font-serif italic text-sm ${dark ? "text-aqua-bright" : "text-aqua"}`}>
          ( {chapter} )
        </span>
      )}
      <span className={`h-px w-10 ${dark ? "bg-white/25" : "bg-ink/20"}`} />
      <span className="kicker">{kicker}</span>
    </div>
    <h2
      className={`mt-5 text-3xl sm:text-4xl lg:text-[2.9rem] font-extrabold tracking-tight leading-[1.08] ${
        dark ? "text-white" : "text-ink"
      }`}
    >
      {title}
    </h2>
    {sub && (
      <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-blue-100/80" : "text-slate-600"}`}>
        {sub}
      </p>
    )}
  </Reveal>
);
